import * as yup from 'yup'

export const defaultAllSurveyDates = [
  { enabled: true, noOfDays: '', condition: '', sectionFieldType: '', surveyDateType: 'Course Section Survey Start Date', subTitle: 'The day the survey for each course section begins.' },
  { enabled: true, noOfDays: '', condition: '', sectionFieldType: '', surveyDateType: 'Course Section Survey End Date', subTitle: 'The day the survey for each course section ends.' },
  { enabled: false, noOfDays: '', condition: '', sectionFieldType: '', surveyDateType: 'Course Section Admin Release Date', subTitle: 'The default day survey results are released to admins for each course section.' },
  { enabled: false, noOfDays: '', condition: '', sectionFieldType: '', surveyDateType: 'Course Section Instructor Release Date', subTitle: 'The default day survey results are released to instructors for each course section.' }
]

export const conditions = [
  { title: 'Before', value: 'before' },
  { title: 'After', value: 'after' },
  { title: 'On', value: 'on' }
]

export const surveyDatesSchema = yup.object().shape({
  enabled: yup.boolean(),
  surveyDatesFilters: yup.array().of(
    yup.object().shape({
      noOfDays: yup.number()
        .transform((value, originalValue) => originalValue === '' ? null : value)
        .when(['enabled'], {
          is: (enabled: boolean) => enabled,
          then: schema => schema.required('Number of days is required')
            .when(['condition'], {
              is: (condition: string) => condition && condition !== 'on',
              then: schema => schema.positive('Please enter at least one day for the survey period')
            }),
          otherwise: schema => schema.notRequired().nullable()
        }),
      condition: yup.string()
        .when('enabled', {
          is: true,
          then: schema => schema.required('Condition for the survey period is required'),
          otherwise: schema => schema.notRequired()
        }),
      sectionFieldType: yup.string()
        .when('enabled', {
          is: true,
          then: schema => schema.required('Academic date is required for the survey'),
          otherwise: schema => schema.notRequired()
        })
    })
  )
})

export const surveyRulesSchema = yup.object().shape({
  isSyncAllSectionsForTermActive: yup.boolean(),
  isReportingHierarchyFilterActive: yup.boolean(),
  isCourseAttributeFilterActive: yup.boolean(),
  minimumEnrollment: yup
    .number()
    .typeError('Enrollment is required')
    .required('Enrollment is required')
    .positive('Enrollment must be a positive number')
    .min(1, 'Enrollment must be at least 1'),
  academicUnits: yup.array().of(yup.object({
    divisionId: yup.string().required('Division ID is required')
  })).when('isReportingHierarchyFilterActive', {
    is: true,
    then: schema => schema.min(1, 'At least one parent academic unit is required'),
    otherwise: schema => schema.nullable()
  }),
  courseFilters: yup.array().of(yup.object({
    op: yup.string().required('Operator is required'),
    value: yup.array().min(1, 'At least one value is required').required('Value is required'),
    key: yup.object().required('Attribute is required')
  })).when('isCourseAttributeFilterActive', {
    is: true,
    then: schema => schema.required('Course filters are required when course attribute filter is active'),
    otherwise: schema => schema.optional()
  })
})
